import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usersDataSelector, userPermissionsSelector } from '../../store1/user login data/user.login.data.slice.slector';
import { PERMISSIONS } from 'routes/permissionsCode';
import { useSelector } from 'react-redux';

import GroupsIcon from '@mui/icons-material/Groups';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ReceiptIcon from '@mui/icons-material/Receipt';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SummarizeIcon from '@mui/icons-material/Summarize';

import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';

import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import CurrencyRupeeOutlinedIcon from '@mui/icons-material/CurrencyRupeeOutlined';
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import KeyboardReturnOutlinedIcon from '@mui/icons-material/KeyboardReturnOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import ContentPasteGoOutlinedIcon from '@mui/icons-material/ContentPasteGoOutlined';
import ContentPasteSearchOutlinedIcon from '@mui/icons-material/ContentPasteSearchOutlined';

import Diversity3OutlinedIcon from '@mui/icons-material/Diversity3Outlined';
import Groups3OutlinedIcon from '@mui/icons-material/Groups3Outlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import PlaylistAddCheckOutlinedIcon from '@mui/icons-material/PlaylistAddCheckOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';

import BallotOutlinedIcon from '@mui/icons-material/BallotOutlined';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined';

import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import RecentActorsOutlinedIcon from '@mui/icons-material/RecentActorsOutlined';

import DashboardCard from 'ui-component/cards/dasboard-card/dashboard-card';
import { gridSpacing } from 'store1/constant';
import { Box, Grid } from '@mui/material';

const Module = () => {
    const userData = useSelector(usersDataSelector);
    const userPermissions = useSelector(userPermissionsSelector);
    const locationName = useLocation().pathname;
    const allModules = {
        '/': [
            {
                Icon: ContentPasteGoOutlinedIcon,
                title: 'My Leaves',
                content: [],
                navigateTo: `/dashboard/my-leaves`,
                permission: PERMISSIONS.HR.LEAVE.VIEW_SELF
            },

            {
                Icon: FormatListBulletedOutlinedIcon,
                title: 'My Expenses',
                content: [],
                navigateTo: `/dashboard/my-expenses`,
                permission: PERMISSIONS.EXPENSES.EXPENSE.VIEW_SELF
            },

            {
                Icon: FormatListBulletedOutlinedIcon,
                title: 'Salary Slip',
                content: [],
                navigateTo: `${locationName}/my-salary-slip`,
                permission: PERMISSIONS.HR.LEAVE.VIEW_SELF
            }
        ],
        '/dashboard': [
            {
                Icon: ContentPasteGoOutlinedIcon,
                title: 'My Leaves',
                content: [],
                navigateTo: `${locationName}/my-leaves`,
                permission: PERMISSIONS.HR.LEAVE.VIEW_SELF
            },
            {
                Icon: FormatListBulletedOutlinedIcon,
                title: 'My Expenses',
                content: [],
                navigateTo: `${locationName}/my-expenses`,
                permission: PERMISSIONS.EXPENSES.EXPENSE.VIEW_SELF
            },
            {
                Icon: FormatListBulletedOutlinedIcon,
                title: 'Salary Slip',
                content: [],
                navigateTo: `${locationName}/my-salary-slip`,
                permission: PERMISSIONS.HR.EMPLOYEE.SALARY
            }
        ],
        '/employee-management': [
            {
                Icon: BadgeOutlinedIcon,
                title: 'Employees List',
                content: [],
                navigateTo: `${locationName}/employees-list`,
                permission: PERMISSIONS.HR.EMPLOYEE.LIST
            },
            {
                Icon: CurrencyRupeeOutlinedIcon,
                title: 'Payroll Management',
                content: [],
                navigateTo: `${locationName}/payroll-management`,
                permission: PERMISSIONS.HR.EMPLOYEE.PAYROLL
            },
            {
                Icon: LogoutOutlinedIcon,
                title: 'Leave Management',
                content: [],
                navigateTo: `${locationName}/leave-management`
            }
        ],
        '/employee-management/leave-management': [
            {
                Icon: ContentPasteGoOutlinedIcon,
                title: 'Employee Leaves',
                content: [],
                navigateTo: `${locationName}/employee-leaves`
            },
            {
                Icon: ContentPasteSearchOutlinedIcon,
                title: 'Leaves Summary',
                content: [],
                navigateTo: `${locationName}/leave-summary`,
                permission: PERMISSIONS.REPORTS.LEAVE_SUMMARY
            }
        ],
        '/manage-accounts/client-list': [
            {
                Icon: GroupsIcon,
                title: 'Client List',
                content: [],
                navigateTo: `${locationName}/client-list`,
                permission: PERMISSIONS.FINANCE.INVOICE.CLIENT_LIST
            }
        ],
        '/manage-accounts': [
            {
                Icon: GroupsIcon,
                title: 'Vendor List',
                content: [],
                navigateTo: `${locationName}/vendors-list`
            }
        ],
        '/manage-accounts/invoice-management': [
            {
                Icon: ReceiptIcon,
                title: 'Invoice List',
                subHead: 'Acetech Invoice List',
                content: [],
                navigateTo: `${locationName}/invoice-list`
            }
        ],
        '/manage-accounts/receipt': [
            {
                Icon: AttachMoneyIcon,
                title: 'Payment List',
                content: [],
                navigateTo: `${locationName}/receipt`
            }
        ],

        '/manage-masters': [
            {
                Icon: BusinessOutlinedIcon,
                title: 'Company Master ',
                subHead: 'Acetech Company Master Page',
                content: [],
                navigateTo: `${locationName}/company-master`,
                permission: PERMISSIONS.SYSTEM.MASTER.COMPANY_MASTER
            },
            {
                Icon: DnsOutlinedIcon,
                title: 'Lookup Master',
                subHead: "Project's Master Controller",
                content: [],
                navigateTo: `${locationName}/lookup-master`,
                permission: PERMISSIONS.SYSTEM.MASTER.LOOKUP_MASTER
            },
            {
                Icon: PublicOutlinedIcon,
                title: 'Country Master',
                content: [],
                navigateTo: `${locationName}/country-master`,
                permission: PERMISSIONS.SYSTEM.MASTER.COUNTRY_MASTER
            },
            {
                Icon: GroupAddOutlinedIcon,
                title: 'User Management',
                content: [],
                navigateTo: `${locationName}/user-management`,
                permission: PERMISSIONS.SYSTEM.USER.VIEW
            },
            {
                Icon: AccountCircleIcon,
                title: 'System Security',
                content: [],
                navigateTo: `${locationName}/system-security`,
                permission: PERMISSIONS.SYSTEM.ROLE.VIEW
            }
        ],

        '/manage-accounts': [
            {
                Icon: Diversity3OutlinedIcon,
                title: 'Clients ',
                content: [],
                navigateTo: `${locationName}/client-list`,
                permission: PERMISSIONS.FINANCE.INVOICE.CLIENT_LIST
            },
            {
                Icon: Groups3OutlinedIcon,
                title: 'Vendors ',
                content: [],
                navigateTo: `${locationName}/vendors-list`,
                permission: PERMISSIONS.FINANCE.INVOICE.VENDOR_ADD
            },
            {
                Icon: LocalPrintshopOutlinedIcon,
                title: 'Invoices',
                content: [],
                navigateTo: `${locationName}/invoice-management`,
                permission: PERMISSIONS.FINANCE.INVOICE.VIEW
            },
            {
                Icon: PlaylistAddCheckOutlinedIcon,
                title: 'Receipt',
                content: [],
                navigateTo: `${locationName}/receipt`
            },
            {
                Icon: FormatListBulletedOutlinedIcon,
                title: 'Expenses',
                content: [],
                navigateTo: `${locationName}/expense-management`
            },
            {
                Icon: SummarizeIcon,
                title: 'Reports',
                content: [],
                navigateTo: `${locationName}/reports`
            }
        ],
        '/manage-accounts/reports': [
            {
                Icon: ReceiptOutlinedIcon,
                title: 'Clients Report Summary',
                content: [],
                navigateTo: `${locationName}/client-report-summary`
            },
            {
                Icon: RecentActorsOutlinedIcon,
                title: 'Client Account Detail',
                content: [],
                navigateTo: `${locationName}/client-account-detail`
            }
        ],
        '/manage-accounts/expense-management': [
            {
                Icon: BallotOutlinedIcon,
                title: 'Expenses List',
                subHead: 'Acetech Company Master Page',
                content: [],
                navigateTo: `${locationName}/expenses-list`,
                permission: PERMISSIONS.EXPENSES.EXPENSE.VIEW_ALL

            },
            {
                Icon: TimelineOutlinedIcon,
                title: 'Expenses Report',
                subHead: "Project's Master Controller",
                content: [],
                navigateTo: `${locationName}/expense-report`,
                permission: PERMISSIONS.EXPENSES.EXPENSE.COMPANY_EXPENSE_SUMMARY
            },
            {
                Icon: StickyNote2OutlinedIcon,
                title: 'Expenses Type Detail',
                subHead: "Project's Master Controller",
                content: [],
                navigateTo: `${locationName}/expense-details`,
                permission: PERMISSIONS.EXPENSES.EXPENSE.COMPANY_EXPENSE_SUMMARY
            }
        ],
        '/employee-management/payroll-management': [
            {
                Icon: ContactPageOutlinedIcon,
                title: 'Employee Salaries',
                content: [],
                navigateTo: `${locationName}/employee-salaries`,
                permission: PERMISSIONS.HR.EMPLOYEE.SALARY
            },

            {
                Icon: AttachMoneyIcon,
                title: 'Advance Module',
                content: [],
                navigateTo: `${locationName}/employee-advance`,
                permission: PERMISSIONS.HR.EMPLOYEE.ADVANCE
            },

            {
                Icon: KeyboardReturnOutlinedIcon,
                title: 'Run Payroll',
                content: [],
                navigateTo: `${locationName}/run-payroll`,
                permission: PERMISSIONS.HR.EMPLOYEE.RUN_HISTORY
            },
        ],
    };
    const allowedModules = (allModules[locationName] || []).filter(
        (item) => !item.permission || userPermissions.includes(item.permission)
    );

    return userData.userToken !== null && userData.userToken !== 'logout' ? (
        <Box>
            <Grid container spacing={gridSpacing}>
                {allowedModules.map((item, idx) => (
                    <Grid item xs={12} lg={4}>
                        <DashboardCard data={item} />
                    </Grid>
                ))}
            </Grid>
        </Box>
    ) : (
        <Navigate to="/auth" replace />
    );
};
export default Module;
